import React from "react";
import { Row, Col } from "react-bootstrap";
import { CanvasWithZoomV2 } from "../index";
import style from "./ColorPicker.module.css";

const ColorPicker = ({
  onSelect,
  selectedColor,
  setSelectedColor,
  editCanvasModal,
  setEditCanvasModal,
  handleBrightnessChange,
}) => {
  return (
    <Row className={style.imageContainer}>
      <Col>
        <CanvasWithZoomV2
          onSelect={onSelect}
          selectedColor={selectedColor}
          setSelectedColor={setSelectedColor}
          editCanvasModal={editCanvasModal}
          setEditCanvasModal={setEditCanvasModal}
        />
      </Col>
    </Row>
  );
};

export default ColorPicker;
